/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import LoadingScreen from "components/LoadingScreen";
import { useAuth } from "state/AuthContext";
import PageNoAccess from "pages/FallbackPages/PageNoAccess";

const FallbackManager = () => {
  const { isAuthLoading } = useAuth();
  if (isAuthLoading) {
    return <LoadingScreen className="h-48 w-48" />;
  }
  return <PageNoAccess />;
};

export default FallbackManager;